import {
  createSearchParamsCache,
  type inferParserType,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
} from "nuqs/server"

export type StoreSortBy =
  | "menu_order"
  | "date"
  | "id"
  | "title"
  | "popularity"
  | "rating"
export type StoreSortOrder = "asc" | "desc"

export type StoreSearchParamsInput = Record<
  string,
  string | string[] | undefined
>

const DEFAULT_PER_PAGE = 12

export const storeServerParsers = {
  q: parseAsString.withDefault(""),
  orderby: parseAsStringLiteral<StoreSortBy>([
    "menu_order",
    "date",
    "id",
    "title",
    "popularity",
    "rating",
  ]).withDefault("menu_order"),
  order: parseAsStringLiteral<StoreSortOrder>(["asc", "desc"]).withDefault(
    "asc"
  ),
  per_page: parseAsInteger.withDefault(DEFAULT_PER_PAGE),
  reviews_page: parseAsInteger,
}

type StoreParsedQueryState = inferParserType<typeof storeServerParsers>

export interface StoreQueryState
  extends Omit<StoreParsedQueryState, "q" | "reviews_page"> {
  q?: string
}

export const storeSearchParamsCache =
  createSearchParamsCache(storeServerParsers)

export const normalizeStoreSearchParams = (
  searchParams: StoreSearchParamsInput
): StoreQueryState => {
  const parsedState = storeSearchParamsCache.parse(searchParams)
  const query = parsedState.q.trim()

  return {
    q: query.length > 0 ? query : undefined,
    orderby: parsedState.orderby,
    order: parsedState.order,
    per_page:
      Number.isInteger(parsedState.per_page) && parsedState.per_page > 0
        ? parsedState.per_page
        : DEFAULT_PER_PAGE,
  }
}

export const hasAnyStoreQueryParam = (
  searchParams: StoreSearchParamsInput
): boolean => {
  for (const value of Object.values(searchParams)) {
    if (Array.isArray(value) && value.length > 0) {
      return true
    }

    if (typeof value === "string" && value.length > 0) {
      return true
    }
  }

  return false
}
